import type { StoreJsonResponse } from "@/stores/common/store.core";
import { Store } from "@/stores/common/store.core";

import type { GetContextedCardsResponse } from "@laborchart-modules/lc-core-api/dist/api/assignments/get-contexted-cards";
type SmartBenchSuggestionsParams = {
   project_id: string;
   request_id: string;
   max_resource_combinations?: number;
   max_duration_days_to_serve?: number;
   job_title_exact_match?: boolean;
   proximity_cutoff?: number;
   similar_job_title_text_similarity_cutoff?: number;
   similar_job_title_previous_assignment_count_cutoff?: number;
   similar_job_title_previous_assignment_percent_cutoff?: number;
   page: number;
   page_size: number;
};

export abstract class BoardsStore extends Store {
   static getSmartBenchSuggestions(
      params: SmartBenchSuggestionsParams,
   ): StoreJsonResponse<GetContextedCardsResponse> {
      return this.requestJson({
         url: `/api/v3/boards/smart-bench`,
         method: "POST",
         body: params,
      });
   }
}
